// App-Exclusive Deal Banner — Annabelle's Wigs
// Only shown to users browsing via the installed PWA (standalone mode)
(function () {
  'use strict';

  // Only run in standalone (installed app) mode
  var isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  if (!isStandalone) return;

  // Only show banner once per browser session
  var SESSION_KEY = 'app_deal_shown';
  if (sessionStorage.getItem(SESSION_KEY)) return;

  // Fetch active deal from Worker
  fetch('/app-deal', { method: 'GET', cache: 'no-store' })
    .then(function (res) {
      if (res.status === 204 || !res.ok) return null;
      return res.json();
    })
    .then(function (deal) {
      if (!deal) return;
      if (Date.now() > deal.expiresAt) return;
      showDealBanner(deal);
    })
    .catch(function (err) {
      console.warn('app-deal: fetch failed', err);
    });

  function showDealBanner(deal) {
    var banner = document.getElementById('app-deal-banner');
    if (!banner) return;

    var labelEl = banner.querySelector('.app-deal__label');
    if (labelEl) {
      labelEl.textContent = formatLabel(deal);
    }

    var codeEl = banner.querySelector('.app-deal__code');
    if (codeEl) {
      codeEl.textContent = deal.code;
    }

    var noteEl = banner.querySelector('.app-deal__note');
    if (noteEl) {
      if (deal.minOrder) {
        noteEl.textContent = 'Min. spend \u00a3' + deal.minOrder;
        noteEl.style.display = '';
      } else {
        noteEl.style.display = 'none';
      }
    }

    startCountdown(banner.querySelector('.app-deal__countdown'), deal.expiresAt);

    var applyBtn = banner.querySelector('.app-deal__btn--apply');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        window.location.href = '/discount/' + encodeURIComponent(deal.code);
      });
    }

    var dismissBtn = banner.querySelector('.app-deal__btn--dismiss');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        banner.classList.remove('is-visible');
      });
    }

    sessionStorage.setItem(SESSION_KEY, '1');

    // Slight delay so page-load feels settled
    setTimeout(function () {
      banner.classList.add('is-visible');
    }, 800);
  }

  function formatLabel(deal) {
    if (deal.type === 'percentage') {
      return deal.value + '% off \u2014 app exclusive';
    }
    return '\u00a3' + deal.value + ' off \u2014 app exclusive';
  }

  function startCountdown(el, expiresAt) {
    if (!el) return;

    function tick() {
      var remaining = expiresAt - Date.now();
      if (remaining <= 0) {
        el.textContent = 'Expired';
        var banner = document.getElementById('app-deal-banner');
        if (banner) banner.classList.remove('is-visible');
        return;
      }
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      el.textContent = 'Expires in ' + h + 'h ' + pad(m) + 'm';
    }

    tick();
    var interval = setInterval(function () {
      var remaining = expiresAt - Date.now();
      if (remaining <= 0) {
        clearInterval(interval);
        tick();
      } else {
        tick();
      }
    }, 60000);
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

})();
